import { createIcon } from '../createIcon';

export const DollyFlatbedIconConfig = {
  name: 'DollyFlatbedIcon',
  height: 512,
  width: 640,
  svgPath: 'M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const DollyFlatbedIcon = createIcon(DollyFlatbedIconConfig);

export default DollyFlatbedIcon;